import { createFileRoute, redirect } from '@tanstack/react-router';

/*
 * Списки прошлого поколения: `/discover/posts` со своими «моими заявками» и «избранным», и
 * `/discover/sessions` с «моими сессиями» и «архивом». Единый экран Discover заменил их ещё в
 * марте 2026 (`d82d9402`, «route cleanup»): он сам переключает «все заявки / избранное» и
 * фильтрует сессии. Ссылки на эти адреса из продукта исчезли тогда же, остались только три полосы
 * вкладок внутри самих страниц, у которых все кнопки вели в одно место.
 *
 * Удалить их нельзя: адрес живёт дольше экрана. `/dashboard/discover/posts` стоит кнопкой
 * «Смотреть все заявки» в письме-дайджесте (teamplay-notification, GameWeeklyDigestProvider), и
 * та же ссылка может лежать у кого-то в закладках. Поэтому вход остаётся, но ведёт туда, где
 * человек получит то, за чем шёл.
 *
 * `replace` - чтобы «назад» возвращало на страницу до перехода, а не на этот адрес: иначе кнопка
 * «назад» тут же кидала бы человека обратно в перенаправление.
 */
export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/posts/_posts'
)({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/{-$locale}/dashboard/discover', params, replace: true });
  },
  ssr: false,
});
